import TextareaAutogrow from "stimulus-textarea-autogrow";

// Connects to data-controller="autogrow"
export default class extends TextareaAutogrow {
  connect() {
    super.connect();
    this.element.classList.add("textarea-autogrow");
  }
}
